export default __webpack_public_path__ + "static/media/add-subset.65aa161f.svg";